module.exports = __webpack_public_path__ + "img/04-1-1接入方式.af7c292f.svg";